import createCache from '@emotion/cache';

// Emotion cache key: used as the prefix for generated class names (e.g. sdmu-1abc2def)
export const EMOTION_CACHE_KEY = 'sdmu';

/**
 * Creates an Emotion cache for use with CacheProvider.
 * Use a single cache for the app so Chakra/Emotion styles share it and
 * class names are stable (helps hydration and reduces duplicate style work).
 */
export const createEmotionCache = () =>
  createCache({ key: EMOTION_CACHE_KEY, prepend: true });
